import React, { Component } from 'react';
var stickFlags = {
  'A': 0,
  'db': 0x2,
  'd': 0x4,
  'df': 0x8,
  'b': 0x10,
  'N': 0x20,
  'f': 0x40,
  'ub': 0x80,
  'u': 0x100,
  'uf': 0x200,
  'END':0x8000,
}
var stickImgLookup = {

}
var stickLookup = {
  'END':0x8000,
  'DASHF':0x8001,
  'DASHB':0x8002,
  'SIDESTEPU':0x8003,
  'SIDESTEPD':0x8004,
  'AOP_DOWN':0x8012,
  'CLOTHESLINE':0x8016,
  'TOMBSTONE':0x8018,
  'CANNONBUSTER':0x801E,
  'MANHATDROP':0x8020,
  'VICTORYBOMB':0x8021,
  'MUSCLEBUSTER_COMBO':0x8022,
  'PILEDRIVER':0x8040,
  'GIANTSWING':0x804e,
  'TWISTER':0x804f,
  'BOSTONCRAB':0x8064,
  'FACEBUSTER':0x8065,
  'GIANTSWING_COMBO':0x807A,
  'FLAPJACK':0x807B,
  'TOMAHAWK':0x80AF,
  'MUSCLEBUSTER':0x8090,
  'RAGINGSTORM1':0x8129,
  'RAGINGSTORM2':0x812A,
  'RAGINGSTORM3':0x812B,
  'RAGINGSTORM4':0x812C,
  'QCFQCF1':0x812d,
  'QCFQCF2':0x812e,
  'QCFQCF1':0x812f,
  'QCFQCF2':0x812e
}
var buttonFlags = {
  'NONE': 0,
  '1': 1,
  '2': 0x2,
  '3': 0x4,
  '4': 0x8,
  'RAGE': 0x10,
  'HOLD-1': 0x200,
  'HOLD-2': 0x400,
  'FLAG1': 0x40000000
}
var buttonImageMap = {
  'db':'03',
  'd':'04',
  'df':'05',
  'b':'06',
  'f':'07',
  'ub':'08',
  'u':'09',
  'uf':'10',
  'N':'35',
  '1':'20',
  '2':'21',
  '12':'22',
  '3':'23',
  '13':'24',
  '23':'25',
  '123':'26',
  '4':'27',
  '14':'28',
'24':'29',
'124':'30',
'34':'31',
 '134':'32',
  '234':'33',
   '1234':'34',
 'RAGE':''
}
export function stickStr(val){
  if(val > 0x7FFF){
    for(var key in stickLookup){
      var f = stickLookup[key];
      if(f == val){
        return key
      }
    }
    return '0x'+val.toString(16)
  }
  var tmp = []
  for(var key in stickFlags){
    var f = stickFlags[key];

    if(val & f ){
      var img = buttonImageMap[key];
      if(img){
        tmp.push(<img key={tmp.length} className="buttonImg" src={"/img/GAIJI_"+img+".png"}/>)
      } else {
        tmp.push(<span>{key}</span>)
      }

      val -= f;
    }
  }
  if(val != 0) tmp.push('0x'+val.toString(16))
  return tmp
}

export  function buttonStr(val){
  var tmp = []
  var img = val > 0x40000000;
  for(var key in buttonFlags){
    var f = buttonFlags[key];
    if(val & f){

      if(key != "FLAG1")
        tmp.push(key)
      val -= f;
    }
  }
  img = img && buttonImageMap[tmp.join('')];
  if(val == 0 && img)  return <img className="buttonImg" src={"/img/GAIJI_"+buttonImageMap[tmp.join('')]+".png"}/>
  if(val != 0) return <span>{'0x'+val.toString(16)}</span>

  return tmp
}

export var attackFlags = {
  0x512:'HIGH',
  0x217:'MID',
  0x10F:'LOW',
  0x41F:'SPMID',
  0x707:'!! MID',
  0x806:'!! HIGH',
}
var flows = {
  0x8001:'STAND'
}
export function attackStr(val){
  if(attackFlags[val]){
    return attackFlags[val]
  }
  return val.toString(16);
}
export function flowStr(val){
  if(flows[val]){
    return `#${val.toString(16)} (${flows[val]})`
  }
  return val;
}
export var reqData = {
  3: "FRONT_HIT",
4: "BACK_HIT",
5: "LEFT_HIT",
6: "RIGHT_HIT",
27: "WALL_HIT",
35: "DANGER",
47: "BLOCKED",
48: "BLOCKED2",
72: "NOT_FRONT_TURNED",
80: "LEFT_TURNED",
81: "RIGHT_TURNED",
68: "INCOMING_HIGH",
135: "DEATH",
146: "UKEMI",
147: "UKEMI2",
148: "UKEMI3",
149: "UKEMI4",
150: "LEFT_SIDE",
151: "RIGHT_SIDE",
157: "RAGE",
182: "BODY_WALL",
217: "DISABLED?",
609: "ITEM",
490: "JUGGLE",
491: "JUGGLE_SCREW",
614: "JUGGLE",
615: "TAILSPIN",
}
export function hasReq(data,startIndex,blacklist){
  var i = startIndex;
  var req = data.hitCondition[i++];

  while(req[0] != 0x371){
    if(blacklist.includes(req[0])) return true
    req = data.hitCondition[i++];
  }
  return false
}
export function getMot(data,motId){
  if(motId > 0x7fff){
    motId = data.aliases[motId]
  }
  return data.states[motId];
}
export function getCancels(data,startIndex){
  var cancels = [];
  var i = startIndex;
  var cancel = data.cancel[i++];
  while(cancel.target != 0x800C){
    if(cancel.target == 0x800B){
      var j = cancel.motId;
      var groupCancel = data.groupCancel[j++]
      while(groupCancel.target != 0x800C){
        cancels.push(groupCancel)
        groupCancel = data.groupCancel[j++]
      }
    } else{
      cancels.push(cancel);
    }


    if(cancel.target == 0x8000) break;
    cancel = data.cancel[i++];
  }
  return cancels;
}
export function getHitEffects(data,startIndex){
  var i = startIndex;
  var hitEffects = [];
  var hitEffect = data.hitEffect[i++];

  while(true){
    var req = data.hitCondition[hitEffect.conditionIndex];


    hitEffects.push({hitEffect,req})
    if(req[0] == 0x371) break
    hitEffect = data.hitEffect[i++];

  }
  return hitEffects
}
export function computeRecovery(data,currentMot,tech=true){
  var cancels = getCancels(data,currentMot.cancelId)
  for(var key in cancels){
    var cancel = cancels[key];

    var ukemi = [146,147,148,149].includes(data.hitCondition[cancel.reqId][0]);
    if(tech && ukemi){
      return [cancel.ext,cancel.motId]
    }
    if(key == cancels.length -1 ) {
      return [cancel.ext,cancel.motId]
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils.js